import PublicLayout from '../../../components/public/PublicLayout';
import Hero from '../../../components/public/Hero';
import { NoRealData } from '@/components/shared';

export default function DossierPage(){return <PublicLayout><Hero title="Dossiê do Exemplar Arbóreo" subtitle="Prontuário público de cada árvore de Goiânia." description="Identificação, localização, laudos, vistorias, manejos e fotos de um exemplar arbóreo." />
 <div className="page-pad">
  <NoRealData variant="page" title="Dossiê do exemplar arbóreo" description="A consulta pública do prontuário (identificação, laudos, vistorias, manejos e fotos) ainda não está disponível." icon="ri-file-list-3-line"/>
 </div>
 </PublicLayout>}
